export const LIMIT = 10;
export const UPLOAD_CONST = '';
export const URI = 'https://marketplace.luhaifdigitech.com';
// export const URI = "http://localhost:5085";
